export default __webpack_public_path__ + "static/media/MaskGroup313.965d5d17.png";